import { coreServicesApiClient } from '@protector/api-client';
import type { GetAllRolesByUserResponse, RBACGetWorkspaceOperationsResponse, RBACOperations } from './models.ts';

export async function getAllRolesByUser(userId?: string): Promise<GetAllRolesByUserResponse | undefined> {
  if (!userId) return undefined;
  const response = await coreServicesApiClient.request<unknown, GetAllRolesByUserResponse>({
    config: {
      method: 'GET',
      url: `/v2/accounts/${userId}/roles`
    }
  });
  return response.data;
}

export async function getWorkspaceOperations(operations: RBACOperations[]): Promise<RBACGetWorkspaceOperationsResponse> {
  const response = await coreServicesApiClient.request<unknown, RBACGetWorkspaceOperationsResponse>({
    config: {
      method: 'POST',
      url: '/v2/auth/verify',
      data: { operations }
    }
  });
  return response.data;
}
